import { ToasterService, ToasterConfig } from 'angular2-toaster';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Component, OnInit, Input } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { PadraoService } from "../../service/padrao/padrao.service";
import { ChamadoDTO } from "../../components/transferobjects/consulta-chamado/chamado";
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { MatFormFieldControl } from '@angular/material';

@Component({
  selector: "app-consultar-chamado",
  templateUrl: "./consultar-chamado.component.html",
  styleUrls: ["./consultar-chamado.component.css"],
  providers: [PadraoService, { provide: MatFormFieldControl, useExisting: FormBuilder }]
})
export class ConsultarChamadoComponent implements OnInit {
  registerForm: FormGroup;
  chamado: ChamadoDTO;
  @BlockUI() loading: NgBlockUI;
  show: boolean;
  recaptcha: ReCaptchaV3Service;

  constructor(private formBuilder: FormBuilder, private padraoService: PadraoService, private toast: ToasterService) { }

  ngOnInit() {
    this.chamado = new ChamadoDTO();

    this.registerForm = this.formBuilder.group({
      numeroChamado: ['', Validators.required],
      email: ['', Validators.required],
      status: [''],
      comentarios: ['']
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  public config: ToasterConfig =
    new ToasterConfig({
      showCloseButton: false,
      tapToDismiss: false,
      timeout: 9000
    });

  consultaChamado(numeroChamado: string, email: string) {
    this.loading.start('Estamos consultando seu chamado. Aguarde um momento...');
    this.padraoService.consultarChamado(numeroChamado, email).subscribe(response => {
      this.chamado = response;
      this.show = true;
      this.loading.stop();
    }, (error) => {
      this.show = false;
      this.toast.pop('warning', 'Chamado não encontrado.', 'Número do chamado e/ou e-mail estão incorretos. Por favor tente novamente.')
      this.loading.stop();
    });
  }
}
